import { genericUpsellOptionsDefault } from '@basket/types/BasketUpsellGenericContext';
import { createContext } from 'preact/compat';
import { optionsDefaults as bookingFormOptionsDefaults, } from '@bookingForm/context/Options';
export const optionsDefaults = {
    ...genericUpsellOptionsDefault,
    type: 'reservation-form',
    bookingForm: bookingFormOptionsDefaults,
    formTitle: undefined,
    buttonText: 'Reserve',
};
export const BasketUpsellReservationFormCTX = createContext(optionsDefaults);
